import {
  getTableData,
  getRoleData,
  saveUser,
  getUserDetail,
  getUserCompanyDetail,
  updateUser,
  updateUserCompany,
  resetPassword,
  changeAuth,
  getDefaultRole,
  deregistration,
  getInactiveList,
  setRole,
  setAccounts,
  analysisAccount,
  deleteRoles,
  getRegisterList,
  getUserCompanyList,
  manageActivate,
  downloadFile,
  delUserCompany,
  getFileFlow
} from '@/axios/api/accounts'
import { getSubmitBy } from '@/axios/api/dictionary'
import { Message } from 'element-ui'
import moment from 'moment'

const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_REGISTER_TABLE_LOADING = 'UPDATE_REGISTER_TABLE_LOADING'
const UPDATE_USER_COMPANY_TABLE_LOADING = 'UPDATE_USER_COMPANY_TABLE_LOADING'
const UPDATE_DET_LOADING = 'UPDATE_DET_LOADING'
const UPDATE_USER_COMPANY_DETAIL_LOADING = 'UPDATE_USER_COMPANY_DETAIL_LOADING'
const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_PARAMS = 'UPDATE_PARAMS'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_ROLE_LIST = 'UPDATE_ROLE_LIST'
const UPDATE_ROLE_DETAIL = 'UPDATE_ROLE_DETAIL'
const UPDATE_USER_CONMANY_DETAIL = 'UPDATE_USER_CONMANY_DETAIL'
const UPDATE_INACTIVE_LIST = 'UPDATE_INACTIVE_LIST'
const UPDATE_REGISTER_LIST = 'UPDATE_REGISTER_LIST'
const UPDATE_USER_COMPANY_LIST = 'UPDATE_USER_COMPANY_LIST'
const UPDATE_INACTIVE_PARAMS = 'UPDATE_INACTIVE_PARAMS'
const UPDATE_REGISTER_PARAMS = 'UPDATE_REGISTER_PARAMS'
const UPDATE_USER_COMPANY_PARAMS = 'UPDATE_USER_COMPANY_PARAMS'
const UPDATE_INACTIVE_SEARCH = 'UPDATE_INACTIVE_SEARCH'
const UPDATE_REGISTER_SEARCH = 'UPDATE_REGISTER_SEARCH'
const UPDATE_USER_COMPANY_SEARCH = 'UPDATE_USER_COMPANY_SEARCH'
const UPDATE_CUSTOMER_GROUP_LIST = 'UPDATE_CUSTOMER_GROUP_LIST'
const UPDATE_CUSTOMER_COMPANY_LIST = 'UPDATE_CUSTOMER_COMPANY_LIST'
const state = {
  tableData: [],
  tblLoading: false,
  registerTableLoading: false,
  userCompanyTableLoading: false,
  detailLoading: false,
  userCompanyDetailLoading: false,
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  params: {
    id: '',
    account: '',
    phone: '',
    name: '',
    roleId: '',
    dataStatus: [],
    userType: '',
    countryId: '',
    title: '',
    userGroupId: '',
    customerGroupId: '',
    customerCompanyId: ''
  },
  roleList: [],
  detail: {
    account: '',
    dataStatus: '',
    name: '',
    title: '',
    id: '',
    phone: '',
    userRoleVoList: [],
    categoryIds: ''
  },
  userCompanyDetail: {
    id: '',
    company: '',
    customerCompany: '',
    customerGroup: '',
    userType: ''
  },
  inactiveList: [],
  registerList: [],
  userCompanyList: [],
  inactiveParams: {
    id: '',
    account: '',
    phone: '',
    name: '',
    roleId: '',
    dataStatus: [],
    userType: '',
    countryId: '',
    title: '',
    userGroupId: ''
  },
  inactivePager: {
    current: 1,
    size: 10,
    total: 0
  },
  registerPager: {
    current: 1,
    size: 10,
    total: 0
  },
  registerParams: {
    id: '',
    account: '',
    phone: '',
    name: '',
    registerStatus: '',
    countryId: '',
    company: '',
    departmentId: ''
  },
  userCompanyParams: {
    id: '',
    name: '',
    customerCompany: '',
    customerGroup: '',
    userType: ''
  },
  userCompanyPager: {
    current: 1,
    size: 10,
    total: 0
  },
  customerGroupList: [],
  customerCompanyList: []
}

const getters = {
  tableData: state => state.tableData.map(v => {
    return {
      ...v,
      role: v.userRoleVoList.map(item => item.name).join(','),
      roleExpireTime: v.roleExpireTime ? moment(v.roleExpireTime * 1000).format('YYYY-MM-DD') : ''
    }
  }),
  inactiveList: state => state.inactiveList.map(v => {
    return {
      ...v,
      role: v.userRoleVoList.map(item => item.name).join(','),
      roleExpireTime: v.roleExpireTime ? moment(v.roleExpireTime * 1000).format('YYYY-MM-DD') : '',
      lastLoginDate: v.lastLoginDate ? moment(v.lastLoginDate * 1000).format('YYYY-MM-DD HH:mm:SS') : ''
    }
  }),
  registerList: state => state.registerList,
  userCompanyList: state => state.userCompanyList,
  roleList: state => state.roleList.map(v => {
    return {
      label: v.name,
      value: v.id,
      roleType: v.roleType
    }
  }),
  tblLoading: state => state.tblLoading,
  registerTableLoading: state => state.registerTableLoading,
  userCompanyTableLoading: state => state.userCompanyTableLoading,
  detailLoading: state => state.detailLoading,
  userCompanyDetailLoading: state => state.userCompanyDetailLoading,
  pager: state => state.pager,
  inactivePager: state => state.inactivePager,
  registerPager: state => state.registerPager,
  params: state => state.params,
  inactiveParams: state => state.inactiveParams,
  registerParams: state => state.registerParams,
  detail: state => {
    let { account, password, dataStatus, name, title, id, phone, expert, countryId, categoryIds, userType, userGroupIds, roleExpireTime, lastExpireRoleIdsName, lastRoleExpireTime, moduleIds } = { ...state.detail }
    try {
      categoryIds = categoryIds ? categoryIds.split(',').map(v => Number(v)) : []
      moduleIds = moduleIds ? moduleIds.split(',').map(v => Number(v)) : []
      userGroupIds = userGroupIds ? userGroupIds.split(',').map(v => Number(v)) : []
      roleExpireTime = roleExpireTime ? new Date(roleExpireTime * 1000) : ''
      lastRoleExpireTime = lastRoleExpireTime ? moment(lastRoleExpireTime * 1000).format('YYYY-MM-DD') : false
    } catch (e) {
      categoryIds = []
      moduleIds = []
      userGroupIds = []
      roleExpireTime = ''
      lastRoleExpireTime = false
    }
    return {
      ...state.detail,
      account,
      dataStatus,
      name,
      title,
      id,
      phone,
      expert,
      password,
      countryId,
      categoryIds,
      moduleIds,
      userType,
      roleIdList: state.detail.userRoleVoList.map(v => v.id),
      userGroupIds,
      roleExpireTime,
      lastExpireRoleIdsName,
      lastRoleExpireTime
    }
  },
  userCompanyDetail: state => state.userCompanyDetail,
  userCompanyParams: state => state.userCompanyParams,
  userCompanyPager: state => state.userCompanyPager,
  customerGroupList: state => state.customerGroupList,
  customerCompanyList: state => state.customerCompanyList
}

const mutations = {
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_REGISTER_TABLE_LOADING] (state, registerTableLoading) {
    state.registerTableLoading = registerTableLoading
  },
  [UPDATE_USER_COMPANY_TABLE_LOADING] (state, userCompanyTableLoading) {
    state.userCompanyTableLoading = userCompanyTableLoading
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_PARAMS] (state, params) {
    state.params = { ...state.params, params }
  },
  [UPDATE_INACTIVE_PARAMS] (state, inactiveParams) {
    state.inactiveParams = { ...state.inactiveParams, inactiveParams }
  },
  [UPDATE_REGISTER_PARAMS] (state, registerParams) {
    state.registerParams = { ...state.registerParams, registerParams }
  },
  [UPDATE_USER_COMPANY_PARAMS] (state, userCompanyParams) {
    state.userCompanyParams = { ...state.userCompanyParams, userCompanyParams }
  },
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = { ...state.pager, ...pager }
    if (params) state.params = params
  },
  [UPDATE_INACTIVE_SEARCH] (state, { pager, params }) {
    state.inactivePager = { ...state.inactivePager, ...pager }
    if (params) state.inactiveParams = params
  },
  [UPDATE_REGISTER_SEARCH] (state, { pager, params }) {
    state.registerPager = { ...state.registerPager, ...pager }
    if (params) state.registerParams = params
  },
  [UPDATE_USER_COMPANY_SEARCH] (state, { pager, params }) {
    state.userCompanyPager = { ...state.userCompanyPager, ...pager }
    console.log(state.userCompanyPager)
    if (params) state.userCompanyParams = params
  },
  [UPDATE_ROLE_LIST] (state, roleList) {
    state.roleList = roleList
  },
  [UPDATE_DET_LOADING] (state, detailLoading) {
    state.detailLoading = detailLoading
  },
  [UPDATE_USER_COMPANY_DETAIL_LOADING] (state, detailLoading) {
    state.userCompanyDetailLoading = detailLoading
  },
  [UPDATE_ROLE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [UPDATE_USER_CONMANY_DETAIL] (state, detail) {
    state.userCompanyDetail = detail
  },
  [UPDATE_INACTIVE_LIST] (state, inactiveList) {
    state.inactiveList = inactiveList
  },
  [UPDATE_REGISTER_LIST] (state, registerList) {
    state.registerList = registerList
  },
  [UPDATE_USER_COMPANY_LIST] (state, userCompanyList) {
    state.userCompanyList = userCompanyList
  },
  [UPDATE_CUSTOMER_GROUP_LIST] (state, customerGroupList) {
    state.customerGroupList = customerGroupList
  },
  [UPDATE_CUSTOMER_COMPANY_LIST] (state, customerCompanyList) {
    state.customerCompanyList = customerCompanyList
  }
}

const actions = {
  async getTableDataApi ({commit}, params) {
    // 非数字类型不可搜索
    if (isNaN(params.id)) {
      commit(UPDATE_TABLEDATA, [])
      commit(UPDATE_TOTAL, 0)
      return
    }
    commit(UPDATE_TBL_LOADING, true)
    try {
      let { data: res } = await getTableData(params)
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {}
    commit(UPDATE_TBL_LOADING, false)
  },
  setParamsApi ({commit}, params) {
    commit(UPDATE_PARAMS, params)
  },
  setInactiveParamsApi ({commit}, params) {
    commit(UPDATE_INACTIVE_PARAMS, params)
  },
  setRegisterParamsApi ({commit}, params) {
    commit(UPDATE_REGISTER_PARAMS, params)
  },
  setUserCompanyParamsApi ({commit}, params) {
    commit(UPDATE_USER_COMPANY_PARAMS, params)
  },
  async getRoleDataApi ({commit}) {
    try {
      const { data: res } = await getRoleData()
      commit(UPDATE_ROLE_LIST, res)
    } catch (e) {}
  },
  // 设置page
  setPagerApi ({commit}, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  // 设置page
  setInactivePagerApi ({commit}, pager) {
    commit(UPDATE_INACTIVE_SEARCH, { pager })
  },
  // 设置retister page
  setRegisterPagerApi ({commit}, pager) {
    commit(UPDATE_REGISTER_SEARCH, { pager })
  },
  // 设置user company page
  setUserCompanyPagerApi ({commit}, pager) {
    commit(UPDATE_USER_COMPANY_SEARCH, { pager })
  },
  // 新增保存用户
  async saveUserApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      await saveUser(params)
      Message.success('success')
      commit(UPDATE_DET_LOADING, false)
      return true
    } catch (e) {
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  // 更新用户信息
  async updateUserApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      await updateUser(params)
      Message.success('success')
      commit(UPDATE_DET_LOADING, false)
      return true
    } catch (e) {
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  // 更新用户信息
  async updateUserCompanyApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      const res = await updateUserCompany(params)
      commit(UPDATE_DET_LOADING, false)
      return res && res.errorCode === 200
    } catch (e) {
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  async getUserDetailApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      const { data: res } = await getUserDetail(params)
      commit(UPDATE_ROLE_DETAIL, res)
    } catch (e) {}
    commit(UPDATE_DET_LOADING, false)
  },
  async getUserCompanyDetailApi ({commit}, params) {
    commit(UPDATE_USER_COMPANY_DETAIL_LOADING, true)
    try {
      const { data: res } = await getUserCompanyDetail(params)
      commit(UPDATE_USER_CONMANY_DETAIL, res)
    } catch (e) {}
    commit(UPDATE_USER_COMPANY_DETAIL_LOADING, false)
  },
  // 清空搜索条件
  clearSearchApi ({state, commit}) {
    const pager = {
      ...state.pager,
      current: 1
    }
    const params = {
      ...state.params,
      id: '',
      account: '',
      phone: '',
      email: '',
      roleId: '',
      dataStatus: [],
      customerGroupId: '',
      customerCompanyId: ''
    }
    commit(UPDATE_SEARCH, { pager, params })
  },
  // 清空搜索条件
  clearRegisterSearchApi ({state, commit}) {
    const pager = {
      ...state.registerPager,
      current: 1
    }
    const params = {
      ...state.registerParams,
      id: '',
      account: '',
      phone: '',
      name: '',
      registerStatus: '',
      countryId: '',
      company: '',
      departmentId: ''
    }
    commit(UPDATE_REGISTER_SEARCH, { pager, params })
  },
  // 清空搜索条件
  clearUserCompanySearchApi ({state, commit}) {
    const pager = {
      ...state.userCompanyPager,
      current: 1
    }
    const params = {
      ...state.userCompanyParams,
      id: '',
      name: '',
      customerCompany: '',
      customerGroup: '',
      userType: ''
    }
    commit(UPDATE_USER_COMPANY_SEARCH, { pager, params })
  },
  // 重置密码
  async resetPasswordApi ({ commit }, params) {
    try {
      const res = await resetPassword(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 修改权限发送邮件
  async changeAuthApi ({ commit }, params) {
    try {
      await changeAuth(params)
      Message.success('success')
    } catch (e) {}
  },
  async getDefaultRoleApi () {
    try {
      const { data: res } = await getDefaultRole()
      return res
    } catch (e) {
      return false
    }
  },
  async deregistrationApi ({ commit }, params) {
    try {
      const { data: res } = await deregistration(params)
      return res
    } catch (e) {
      return false
    }
  },
  async searchUserListApi ({ commit }, params) {
    try {
      const { data: res } = await getSubmitBy(params)
      return res || []
    } catch (e) {
      return false
    }
  },
  async getInactiveListApi ({ commit }, params) {
    // 非数字类型不可搜索
    if (isNaN(params.id)) {
      commit(UPDATE_INACTIVE_LIST, [])
      commit(UPDATE_INACTIVE_SEARCH, { pager: { total: 0 } })
      return
    }
    commit(UPDATE_TBL_LOADING, true)
    try {
      let { data: res } = await getInactiveList(params)
      commit(UPDATE_INACTIVE_LIST, res.records)
      commit(UPDATE_INACTIVE_SEARCH, { pager: { total: res.total } })
    } catch (e) {}
    commit(UPDATE_TBL_LOADING, false)
  },
  async getRegisterListApi ({ commit }, params) {
    // 非数字类型不可搜索
    if (isNaN(params.id)) {
      commit(UPDATE_REGISTER_LIST, [])
      commit(UPDATE_REGISTER_SEARCH, { pager: { total: 0 } })
      return
    }
    commit(UPDATE_REGISTER_TABLE_LOADING, true)
    try {
      let { data: res } = await getRegisterList(params)
      commit(UPDATE_REGISTER_LIST, res.records)
      commit(UPDATE_REGISTER_SEARCH, { pager: { total: res.total } })
    } catch (e) {}
    commit(UPDATE_REGISTER_TABLE_LOADING, false)
  },
  // 删除
  async delUserCompanyApi ({ commit }, params) {
    try {
      const res = await delUserCompany(params)
      return res && res.errorCode === 200
    } catch (e) {}
  },
  async getUserCompanyListApi ({ commit }, params) {
    // 非数字类型不可搜索
    if (isNaN(params.id)) {
      commit(UPDATE_USER_COMPANY_LIST, [])
      commit(UPDATE_USER_COMPANY_SEARCH, { pager: { total: 0 } })
      return
    }
    commit(UPDATE_USER_COMPANY_TABLE_LOADING, true)
    try {
      let { data: res } = await getUserCompanyList(params)
      commit(UPDATE_USER_COMPANY_LIST, res.records)
      commit(UPDATE_USER_COMPANY_SEARCH, { pager: { total: res.total } })
    } catch (e) {}
    commit(UPDATE_USER_COMPANY_TABLE_LOADING, false)
  },
  async setRoleApi ({ commit }, params) {
    try {
      const { data: res } = await setRole(params)
      return res
    } catch (e) {
      return false
    }
  },
  async setAccountsApi ({ commit }, params) {
    try {
      const { data: res } = await setAccounts(params)
      return res
    } catch (e) {
      return false
    }
  },
  async analysisAccountApi ({ commit }, params) {
    try {
      const { data: res } = await analysisAccount(params)
      return res
    } catch (e) {
      return false
    }
  },
  async deleteRolesApi ({ commit }, params) {
    try {
      const { data: res } = await deleteRoles(params)
      return res
    } catch (e) {
      return false
    }
  },
  async manageActivateApi ({ commit }, params) {
    try {
      await manageActivate(params)
      return true
    } catch (e) {
      return false
    }
  },
  async downloadFileApi ({ commit }, params) {
    try {
      const res = await downloadFile(params)
      return res || false
    } catch (e) {
      return false
    }
  },
  async getFileFlowApi ({ commit }, params) {
    try {
      const res = await getFileFlow(params)
      return res || false
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/accounts.js